<template>
  <div class="shared-link-password-dialog-box">
    <el-form
      :model="passwordForm"
      @submit="onSubmit">
      <el-dialog
        :title="$t('shared-link.password-dialog-box.title')"
        :show-close="false"
        visible
      >
        <div class="el-text el-text--body-24 mx-24 my-16">
          {{ $t('shared-link.password-dialog-box.message') }}
        </div>

        <el-form-item
          class="mx-24"
          prop="password">
          <el-password
            autofocus
            :is-error="isInvalidPassword"
            v-model="passwordForm.password"
            :label="$t('shared-link.password-dialog-box.hint.password')"
            with-icon
          />
        </el-form-item>

        <template v-if="isInvalidPassword">
          <el-form-error
            class="mx-24 mb-16"
            style="margin-top: -23px;">
            {{ $t('shared-link.password-dialog-box.message.invalid-password') }}
          </el-form-error>
        </template>

        <template slot="footer">
          <el-button
            native-type="submit"
            :loading="isInProgress"
            :disabled="isInProgress"
          >
            {{ $t('shared-link.form.button.open') }}
          </el-button>
        </template>
      </el-dialog>
    </el-form>
  </div>
</template>

<style lang="scss" scoped>

</style>

<script>
import { createNamespacedHelpers } from 'vuex';

import {
  SETUP_LINK_PASSWORD
} from '../store/action-types';

import {
  PENDING_STATUS,
  SUCCESS_STATUS,
  ERROR_STATUS
} from '../store/action-status';

import {
  FOLDER_LINK_TYPE
} from '../store/link-type';

const { mapGetters, mapActions } = createNamespacedHelpers('shared-link');

export default {
  name: 'SharedLinkPasswordDialogBox',
  data() {
    return {
      passwordForm: {
        password: ''
      }
    };
  },
  computed: {
    ...mapGetters([
      'getSetupLinkPasswordStatus',
      'getLinkCipher',
      'getLinkType'
    ]),
    isSuccess() {
      return this.getSetupLinkPasswordStatus === SUCCESS_STATUS;
    },
    isInvalidPassword() {
      return this.getSetupLinkPasswordStatus === ERROR_STATUS;
    },
    isInProgress() {
      return this.getSetupLinkPasswordStatus === PENDING_STATUS;
    }
  },
  methods: {
    ...mapActions({
      setupLinkPassword: SETUP_LINK_PASSWORD
    }),
    onSubmit(e) {
      this.setupLinkPassword({
        linkCipher: this.getLinkCipher,
        password: this.passwordForm.password,
        folderItem: (this.getLinkType === FOLDER_LINK_TYPE)
      });
    }
  }
};

</script>
